import { DialogHeading, IconButton, NumericChipLabel, NumericChipLabelOwnProps } from 'omakase';
import { IconArrowLeft, IconCrossLarge } from '@tock/icons';
import { IconArrowLeft as IconArrowLeftLegacy, IconClose } from 'ui/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { backArrowIconButton, closeIconButton, heading } from 'omakase/Lightbox/lightboxCssDefs';
import React from 'react';

export interface LightboxHeadingBaseProps {
  onClose?: () => void;
}

export type LightboxHeadingProps = LightboxHeadingBaseProps & NumericChipLabelOwnProps;

const LightboxHeading: React.FunctionComponent<LightboxHeadingProps> = ({
  current,
  total,
  onClose,
}) => {
  return (
    <DialogHeading css={heading} disableTypography>
      <IconButton
        css={backArrowIconButton}
        variant="ghostInverted"
        size="medium"
        aria-label="Go back"
        onClick={onClose}
        data-testid="close-lightbox-mobile"
      >
        <IconMigrationUtil legacyIcon={<IconArrowLeftLegacy />} newIcon={<IconArrowLeft />} />
      </IconButton>
      <NumericChipLabel
        variant="ghost"
        highContrast={true}
        current={current}
        total={total}
        size="large"
        onClick={onClose}
      />
      <IconButton
        css={closeIconButton}
        variant="ghostInverted"
        size="medium"
        aria-label="Go back"
        onClick={onClose}
        data-testid="close-lightbox-desktop"
      >
        <IconMigrationUtil legacyIcon={<IconClose />} newIcon={<IconCrossLarge />} />
      </IconButton>
    </DialogHeading>
  );
};

export default LightboxHeading;
